import { Outlet } from 'react-router-dom';
import './styles';
import classes from './style.module.css';

const LandingLayout = () => (
  <div className={classes.layout}>
    <main>
      <Outlet />
    </main>
  </div>
);

export default LandingLayout;
